import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-49de3dc2")

_pushScopeId("data-v-49de3dc2")
const _hoisted_1 = { class: "signup-privacy-policy" }
const _hoisted_2 = { class: "signup-privacy-policy__content" }
const _hoisted_3 = { class: "agree" }
const _hoisted_4 = { class: "p-field-checkbox" }
const _hoisted_5 = /*#__PURE__*/_createVNode("label", {
  for: "agree1",
  class: "-medium"
}, [
  /*#__PURE__*/_createTextVNode(" 個人情報収集利用同意 "),
  /*#__PURE__*/_createVNode("span", { class: "-required" }, "(必須)")
], -1)
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<table class=\"-medium\" data-v-49de3dc2><thead data-v-49de3dc2><tr data-v-49de3dc2><th data-v-49de3dc2>目的</th><th data-v-49de3dc2>アイテム</th><th data-v-49de3dc2>保持期間</th></tr></thead><tbody data-v-49de3dc2><tr data-v-49de3dc2><td data-v-49de3dc2><span data-v-49de3dc2>ユーザー識別と会員管理</span></td><td data-v-49de3dc2><span data-v-49de3dc2>電子メール、名前、携帯電話番号、性別</span></td><td data-v-49de3dc2><span data-v-49de3dc2>会員脱退後すぐに削除</span></td></tr></tbody></table>", 1)
const _hoisted_7 = { class: "agree" }
const _hoisted_8 = { class: "p-field-checkbox" }
const _hoisted_9 = /*#__PURE__*/_createVNode("label", {
  for: "agree2",
  class: "-medium"
}, [
  /*#__PURE__*/_createTextVNode(" 画像相談中の映像活用同意 "),
  /*#__PURE__*/_createVNode("span", { class: "-required" }, "(必須)")
], -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "-vector" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("p", null, " 円滑な処方のために医師が火傷相談中に診断に必要な病変、創傷 など外観的な身体画像を保存することができ、処方以外の目的で 活用されないことをお知らせします。 ", -1)
const _hoisted_12 = { class: "agree" }
const _hoisted_13 = { class: "p-field-checkbox" }
const _hoisted_14 = /*#__PURE__*/_createVNode("label", {
  for: "agree3",
  class: "-medium"
}, [
  /*#__PURE__*/_createTextVNode(" 会員登録の留意事項の確認と同意 "),
  /*#__PURE__*/_createVNode("span", { class: "-required" }, "(必須)")
], -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "-vector" }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { class: "ps" }, [
  /*#__PURE__*/_createVNode("span", null, "人的事項 虚偽記載又は人の盗用に関する責任"),
  /*#__PURE__*/_createVNode("p", null, [
    /*#__PURE__*/_createVNode("ol", null, [
      /*#__PURE__*/_createVNode("li", null, "1. 会員が会員登録時に氏名、生年月日などの人的事項を虚偽記載したり、他人の人的事項を盗用した場合には、関連法令により刑事処罰を受けることができます。"),
      /*#__PURE__*/_createVNode("li", null, "2. 会社と医療機関は、会員が第1項のように人的事項虚偽の記載または他人名の盗用を通じて本サービスを利用する場合には、サービス利用により発生した会員の損害を賠償する責任はありません。"),
      /*#__PURE__*/_createVNode("li", null, "3. 会員の虚偽の記載または名義の盗用により会社または医療機関と損害が発生した場合、会員は会社および医療機関に対して損害賠償責任を負います。")
    ])
  ])
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Checkbox = _resolveComponent("Checkbox")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode(_component_Checkbox, {
            id: "agree1",
            modelValue: _ctx.state.agree1,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.state.agree1 = $event)),
            class: "-royalBlue check-box",
            binary: true
          }, null, 8, ["modelValue"]),
          _hoisted_5
        ]),
        _hoisted_6
      ]),
      _createVNode("div", _hoisted_7, [
        _createVNode("div", _hoisted_8, [
          _createVNode(_component_Checkbox, {
            id: "agree2",
            modelValue: _ctx.state.agree2,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.state.agree2 = $event)),
            binary: true,
            class: "-royalBlue check-box"
          }, null, 8, ["modelValue"]),
          _hoisted_9
        ]),
        _hoisted_10,
        _hoisted_11
      ]),
      _createVNode("div", _hoisted_12, [
        _createVNode("div", _hoisted_13, [
          _createVNode(_component_Checkbox, {
            id: "agree3",
            modelValue: _ctx.state.agree3,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.state.agree3 = $event)),
            binary: true,
            class: "-royalBlue check-box"
          }, null, 8, ["modelValue"]),
          _hoisted_14
        ]),
        _hoisted_15,
        _hoisted_16
      ])
    ])
  ]))
})